import type { Role } from '../../lib/sessionContext';

export type OrgRole = Exclude<Role, 'operator'>;

export const ROLE_LABEL: Record<Role, string> = {
  owner: 'Owner',
  admin: 'Admin',
  editor: 'Editor',
  viewer: 'Viewer',
  seller: 'Vendedor',
  operator: 'Operador',
};

export const ROLE_HELP: Record<OrgRole, string> = {
  owner: 'Todo, incluida la administración de Owners.',
  admin: 'Lotes, custodia, miembros, API keys y página del partner.',
  editor: 'Crear QR digitales y editar destinos.',
  viewer: 'Solo lectura de QR e inventario.',
  seller: 'Activa en terreno los QR que tiene en custodia.',
};

/** Roles que un miembro puede asignar: un Admin no crea ni degrada Owners (R1.7). */
export function assignableRoles(current: Role | undefined): OrgRole[] {
  const base: OrgRole[] = ['seller', 'editor', 'viewer', 'admin'];
  return current === 'owner' ? [...base, 'owner'] : base;
}

export function requiresMfa(role: Role | string | undefined): boolean {
  return role === 'owner' || role === 'admin' || role === 'operator';
}
